// //========= LOCOMOTIVE SCROLL  ========//
gsap.registerPlugin(ScrollTrigger);


// const locoScroll = new LocomotiveScroll({
//   el: document.querySelector('[data-scroll-container]'),
//   smooth: true,
//   getDirection: true,
//   mobile: {
//     breakpoint: 0,
//     smoothMobile: true,
//     getDirection: true,
//   },
//   tablet: {
//     breakpoint: 0,
//     smooth: false,
//     getDirection: true,
//   }
// })

// new ResizeObserver(() => locoScroll.update()).observe(
//   document.querySelector("[data-scroll-container]")
// );

// locoScroll.on("scroll", ScrollTrigger.update);

// ScrollTrigger.scrollerProxy('[data-scroll-container]', {
//   scrollTop(value) {
//     return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
//     // return arguments.length ? locoScroll.scrollTo(value, {duration: 0, disableLerp: true}) : locoScroll.scroll.instance.scroll.y;

//   },
//   getBoundingClientRect() {
//     return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
//   },
//   pinType: document.querySelector('[data-scroll-container]').style.transform ? "transform" : "fixed"
// });

// // ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
// ScrollTrigger.defaults({ scroller: '[data-scroll-container]' });
// // --- SETUP END ---


// ======== NAVIGATION ========
document.addEventListener('DOMContentLoaded', function() {
  // Updated selector to target both navigation sections
  const navLinks = document.querySelectorAll('nav[aria-label="Transparency Report Navigation"] a[href^="#"]');
  const stickyNav = document.getElementById('sticky-nav');
  const heroNav = document.getElementById('hero-nav');
  
  // Function to handle sticky nav visibility
  function handleStickyNav() {
    if (heroNav) {
      const heroNavRect = heroNav.getBoundingClientRect();
      const isHeroNavVisible = heroNavRect.bottom > 0;
      
      if (isHeroNavVisible) {
        stickyNav.classList.remove('opacity-100');
        stickyNav.classList.add('opacity-0');
      } else {
        stickyNav.classList.remove('opacity-0');
        stickyNav.classList.add('opacity-100');
      }
    }
  }

  // Add scroll event listener
  window.addEventListener('scroll', handleStickyNav, { passive: true });
  
  // Initial check for sticky nav
  handleStickyNav();
  
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // If using locomotive scroll
        if (typeof window.locomotiveScroll !== 'undefined') {
          window.locomotiveScroll.scrollTo(targetElement, {
            offset: -120,
            duration: 1000,
            easing: [0.25, 0.00, 0.35, 1.00]
          });
        } else {
          // Calculate the element's position and subtract 120px
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 120;
          
          // Fallback to regular smooth scroll with offset
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });







  
  // ======== PARALLAX EFFECTS ========
  const parallaxImages = document.querySelectorAll('.parallax-image');
  
  function handleParallax() {
    parallaxImages.forEach(image => {
      // Find the closest wrapper (works for any section using the parallax effect)
      const wrapper = image.closest('.parallax-wrapper, .tr-seeds-hero-banner, .tr-bloom-hero-banner, .tr-ggob-hero-banner, .tr-lean-hero-banner');
      if (!wrapper) return;

      const rect = wrapper.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollPercentage = rect.top / viewportHeight;
      
      // Only apply parallax if the image is in or near the viewport
      if (rect.top < viewportHeight && rect.bottom > 0) {
        const moveAmount = scrollPercentage * -70;
        image.style.transform = `translate3d(0, calc(-50% + ${moveAmount}px), 0)`;
      }
    });
  }

  // Throttle scroll events with requestAnimationFrame
  let waiting = false;
  window.addEventListener('scroll', function() {
    if (!waiting) {
      waiting = true;
      requestAnimationFrame(function() {
        handleParallax();
        waiting = false;
      });
    }
  }, { passive: true });

  // Initial parallax call
  handleParallax();
});










// Comparison Tab

// Tab switching functionality for comparison tabs
document.addEventListener('DOMContentLoaded', function() {
    const tabComponents = document.querySelectorAll('.tr-comparison-tab');
    
    tabComponents.forEach(component => {
        const tabButtons = component.querySelectorAll('.tr-stat-tab');
        const tabContents = component.querySelectorAll('[data-tab]');

        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Remove active class from all tabs within this component
                tabButtons.forEach(tab => tab.classList.remove('tr-stat-tab--active'));
                
                // Add active class to clicked tab
                this.classList.add('tr-stat-tab--active');
                
                // Hide all tab content within this component
                tabContents.forEach(content => content.classList.add('hidden'));
                
                // Show the corresponding tab content
                const tabNumber = Array.from(tabButtons).indexOf(this) + 1;
                const targetContent = component.querySelector(`.tab_${tabNumber}--data`);
                if (targetContent) {
                    targetContent.classList.remove('hidden');
                }
            });
        });
    });
});





//Number scroll animation
document.addEventListener('DOMContentLoaded', function() {
    // For numbers without commas
    const numberElements = document.querySelectorAll('.animate-number');
    numberElements.forEach((numberElement) => {
        gsap.from(numberElement, {
            textContent: 0,
            duration: 0.5,
            ease: "power2.out",
            modifiers: {
                textContent: (value) => Math.round(value)
            },
            scrollTrigger: {
                trigger: numberElement,
                start: "top 85%",
                toggleActions: "play none none reverse",
                markers: false
            }
        });
    });

    // For numbers with commas
    const numberWithCommaElements = document.querySelectorAll('.animate-number-comma');
    numberWithCommaElements.forEach((numberElement) => {
        gsap.from(numberElement, {
            textContent: 0,
            duration: 0.5,
            ease: "power2.out",
            modifiers: {
                textContent: (value) => Math.round(value).toLocaleString()
            },
            scrollTrigger: {
                trigger: numberElement,
                start: "top 85%",
                toggleActions: "play none none reverse",
                markers: false
            }
        });
    });
});

class TrCustomPopup {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.trigger = wrapper.querySelector('.tr-custom-popup-trigger, .cursor-pointer');
    this.popup = wrapper.querySelector('.tr-custom-popup, .fixed.inset-0');
    this.closeBtn = this.popup ? this.popup.querySelector('.board-popup--close') : null;

    if (this.trigger && this.popup) {
      this.trigger.addEventListener('click', this.open.bind(this));
      // Close on close button
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }
      // Close on background click
      this.popup.addEventListener('click', (e) => {
        if (e.target === this.popup) this.close();
      });
    }
  }

  open() {
    this.popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.popup.classList.add('hidden');
    document.body.style.overflow = '';
  }

  // Static method to initialize all popups on the page
  static initAll() {
    document.querySelectorAll('.tr-custom-popup-wrapper').forEach(wrapper => {
      new TrCustomPopup(wrapper);
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  TrCustomPopup.initAll();
});